import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import * as Pages from "../pages";
import { ROUTE_NAMES } from "../constants/routeNames";
import { useDispatch } from "react-redux";
import { SagaActions } from "../redux/actionTypes";
import RedirectLoadingPage from "../pages/redirect/redirectLoadingPage";
import ProtectiveRoutes from "./protectiveRoute";

const PageRoutes = () => {
  const Dispatch = useDispatch();

  useEffect(() => {
    Dispatch({ type: SagaActions.ADD_NEW_UUID });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTE_NAMES.Initial} element={<Pages.LoginPage />} />
        <Route path={ROUTE_NAMES.Signup} element={<Pages.SignupPage />} />
        <Route path="reset-password" element={<Pages.ResetPasswordPage />} />
        <Route
          path={ROUTE_NAMES.FROM_PADMIN}
          element={<RedirectLoadingPage />}
        />

        <Route
          path={ROUTE_NAMES.Home}
          element={
            <ProtectiveRoutes>
              <Pages.HomePage />
            </ProtectiveRoutes>
          }
        >
          <Route
            path={ROUTE_NAMES.Dashboard}
            element={<Pages.DashboardPage />}
          />
          <Route
            path={ROUTE_NAMES.CEP_Dashboard}
            element={<Pages.CEP_DashboardPage />}
          />
          <Route path={ROUTE_NAMES.Clients} element={<Pages.ClientsPage />} />

          <Route path={ROUTE_NAMES.Payments} element={<Pages.PaymentsPage />} />
          <Route
            path={ROUTE_NAMES.Activation}
            element={<Pages.ActivationPage />}
          />
          <Route
            path={ROUTE_NAMES.DeleteUser}
            element={<Pages.DeleteUserPage />}
          />
          <Route
            path={ROUTE_NAMES.CEP}
            element={<Pages.CandidateExpPatnerPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default PageRoutes;
